import { z } from 'zod';
export const textSessionSchema = z.object({
    timeout_minutes: z.number().min(1).max(1440),
    timeout_message: z.string().max(1000),
});
export const updateEngineAgentSchema = z.object({
    name: z.string(),
    llm_id: z.number(),
    voice_id: z.number(),
    stt_config_id: z.number(),
    stt_config_copied: z.boolean(),
    turn_detection_config_id: z.number(),
    turn_detection_config_copied: z.boolean(),
    timeout_config_id: z.number(),
    timeout_config_copied: z.boolean(),
    experiment_tag: z.string().nullable(),
    text_session: textSessionSchema.nullable().optional(),
});
